import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { Colors } from '../../../themes';
import { tokens } from '../../crop-circle/tokens';

export type CounterSummaryProps = {
  initialValueLabel: string;
  initialValue: string | number;
  getDeltaValueLabel: () => string;
  getDeltaValue: () => string;
  getNewValueLabel: () => string;
  getNewValue: () => string;
  useCropCircle?: boolean;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const CounterSummaryOld = (props: CounterSummaryProps) => {
  const { t } = useTranslation();

  const delta = props.getDeltaValue();
  const newVal = props.getNewValue();
  // If initialValue is 0 but both delta and new value are '--', treat initial as optional blank
  const initialDisplay =
    (props.initialValue === 0 || props.initialValue === '0') &&
    delta === '--' &&
    newVal === '--'
      ? '--'
      : props.initialValue;

  return (
    <View style={styles.summaryContainer}>
      <View style={[styles.summaryRow, { marginTop: 0 }]}>
        <Text style={styles.summaryLabel}>{props.initialValueLabel}</Text>
        <Text style={styles.summaryLabel}>{initialDisplay}</Text>
      </View>
      <View style={styles.summaryRow}>
        <Text style={[styles.summaryLabel, styles.changeLabel]}>
          {props.getDeltaValueLabel()}
        </Text>
        <Text style={[styles.summaryLabel, styles.changeLabel]}>{delta}</Text>
      </View>
      <View style={styles.summaryRow}>
        <Text style={[styles.summaryLabel, styles.newValueLabel]}>
          {props.getNewValueLabel()}
        </Text>
        <Text style={[styles.summaryLabel, styles.newValueLabel]}>
          {newVal}
        </Text>
      </View>
    </View>
  );
};

// TODO: Crop Circle Redesign | Remove to CounterSummaryBase after feature is fully rolled out
const CounterSummaryBase = (props: CounterSummaryProps) => {
  const { t } = useTranslation();

  const delta = props.getDeltaValue();
  const newVal = props.getNewValue();
  // If initialValue is 0 but both delta and new value are '--', treat initial as optional blank
  const initialDisplay =
    (props.initialValue === 0 || props.initialValue === '0') &&
    delta === '--' &&
    newVal === '--'
      ? '--'
      : props.initialValue;

  return (
    <View style={stylesCropCircle.summaryContainer}>
      <View style={[stylesCropCircle.summaryRow, { marginTop: 0 }]}>
        <Text
          style={[tokens.typography.body.small, stylesCropCircle.summaryLabel]}
        >
          {props.initialValueLabel}
        </Text>
        <Text
          style={[tokens.typography.body.small, stylesCropCircle.summaryLabel]}
        >
          {initialDisplay}
        </Text>
      </View>
      <View style={stylesCropCircle.summaryRow}>
        <Text
          style={[tokens.typography.body.small, stylesCropCircle.summaryLabel]}
        >
          {props.getDeltaValueLabel()}
        </Text>
        <Text
          style={[tokens.typography.body.small, stylesCropCircle.summaryLabel]}
        >
          {delta}
        </Text>
      </View>
      <View style={stylesCropCircle.summaryRow}>
        <Text
          style={[
            tokens.typography.body.small,
            stylesCropCircle.summaryLabel,
            stylesCropCircle.newValueLabel,
          ]}
        >
          {props.getNewValueLabel()}
        </Text>
        <Text
          style={[
            tokens.typography.body.small,
            stylesCropCircle.summaryLabel,
            stylesCropCircle.newValueLabel,
          ]}
        >
          {newVal}
        </Text>
      </View>
    </View>
  );
};

export const CounterSummary = (props: CounterSummaryProps) => {
  if (props.useCropCircle) {
    return <CounterSummaryBase {...props} />;
  }

  return <CounterSummaryOld {...props} />;
};

const styles = StyleSheet.create({
  summaryContainer: {
    marginTop: 20,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 6,
  },
  summaryLabel: {
    fontSize: 16,
    fontWeight: '400',
    color: Colors.blackText,
    letterSpacing: -0.25,
  },
  changeLabel: {
    color: Colors.info,
  },
  newValueLabel: {
    fontWeight: '500',
  },
});

const stylesCropCircle = StyleSheet.create({
  summaryContainer: {
    marginTop: 16,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 4,
  },
  newValueLabel: {
    fontWeight: '500',
  },
  summaryLabel: {
    color: Colors.slate[500],
    lineHeight: 18,
  },
});
